import { Directive, TemplateRef } from '@angular/core'

@Directive({
  selector: '[app-file-drop-content-tmp]',
  standalone: false,
})
export class FileDropContentTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
